import { ReactComponent as CloseIcon } from 'assets/icons/close_square.svg';
import { IModalContentService } from 'common/contracts';
import { ModalBodyContent, ModalBodyContentLeft, ModalCloseBtn, ModalContainer } from 'common/styles/Modal.styles';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { setSecondaryModalContentOf, updateSecondaryModalVisibility } from 'store/slices/ModalSlice';
import { RootState } from 'store/store';
import CommonUtils from 'utils/common';

const SecondaryModal = ({ modalService }: { modalService: IModalContentService }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const { modalReducer } = useSelector((state: RootState) => state);

  return (
    // <ModalContainer>
    //   <ModalBodyContent open={modalReducer.showSecondaryModal} animation="slide-left" secondary>
    //     <ModalBodyContentLeft secondary>{modalService.getSecondaryModalContent()}</ModalBodyContentLeft>
    //     <ModalCloseBtn
    //       onClick={() => {
    //         dispatch(updateSecondaryModalVisibility(false));
    //         dispatch(setSecondaryModalContentOf(''));
    //         history.push(CommonUtils.path(location.pathname));
    //       }}
    //     >
    //       <CloseIcon />
    //     </ModalCloseBtn>
    //   </ModalBodyContent>
    // </ModalContainer>
    <></>
  );
};

export default SecondaryModal;
